import { baseURL } from './const'
import requestParams from './request-params'
import { I_ERROR, I_RESPONSE } from './types'
import { addApi, reportError, reportInfo, reportWarn } from '../owl'
import { lxMV } from '../lx'

function reportType<T>(response: I_RESPONSE<T>) {
  const status = (response.data && response.data.status) || 0
  if (status !== 0) {
    if (status < 2000 && [401, 406].indexOf(status) === -1) {
      return 'error'
    }
    if ([2001, 2003, 2004, 2007].indexOf(status) !== -1) {
      return 'error'
    }
    if ([406].indexOf(status) !== -1) {
      return 'warn'
    }
  }
  return 'info'
}

export function processReportUrl(url?: string): string {
  if (!url || url.indexOf(baseURL) === -1) return url || ''
  return ((url.split('?')[0] || '').split(baseURL)[1] || '').replace(/(\/)(\d+)(\/?)/gi, '$1:param$3')
}

export function reportReqError(error: I_ERROR) {
  try {
    reportInfo(
      {
        name: 'REQ_ERROR|' + error.message + '|' + processReportUrl(error.config.url),
      },
      { category: 'biz' },
    )
  } catch (e) {
    console.log(error)
  }
  return error
}

export function reportRespInfo<T>(response: I_RESPONSE<T>) {
  // console.log('resp', 1)
  if (response.config.report) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { fingerprint, ...extra } = JSON.parse(response.config.data)
      lxMV('b_airbnb_tlf58hkt_mv', {
        custom: {
          api: response.config.url,
          content: JSON.stringify(extra),
        },
      })
    } catch (err) {
      console.error(err)
      // do nothing
    }
  }
  // console.log('[API Response]', processReportUrl(response.config.url), response.data)
  addApi({
    name: processReportUrl(response.config.url),
    networkCode: response.status,
    statusCode: response.data.status,
    responseTime: response.config._startTime ? Date.now() - response.config._startTime : 0,
  })
  if (response.data.status !== 0 && response.config.url && response.config.url.indexOf(baseURL) !== -1) {
    reportError(
      {
        name:
          processReportUrl(response.config.url) +
          (response.data
            ? '|' + (response.data.message ? response.data.message.replace(/(\d+)/gi, ':param') : '')
            : '') +
          '|' +
          'API_ERROR-' +
          response.data.status,
        msg: [
          requestParams.toString(),
          JSON.stringify(response.config.headers),
          JSON.stringify(response.config.data),
          JSON.stringify(response.data),
          document.cookie,
        ].join('\r\n'),
      },
      {
        level: reportType(response),
        category: 'biz',
      },
    )
  }
  return response
}

export function reportRespError(error: { message: string; config: { url: string } }) {
  if (['request aborted', 'network error', 'timeout'].every((i) => error.message.toLowerCase().indexOf(i) === -1)) {
    try {
      reportWarn(
        {
          name: 'RES_ERROR|' + error.message + '|' + processReportUrl(error.config.url),
          msg: error,
        },
        { category: 'ajaxError' },
      )
    } catch (e) {
      console.log(error)
    }
  }
  return error
}
